import Button from 'components/button/Button';
import { useAutomationsTabs } from 'pages/automations/AutomationsTabs';
import { useTranslation } from 'react-i18next';

const PreviewPreArrivalFormButton = ({
  isPreviewOpen,
  setIsPreviewOpen,
}: {
  isPreviewOpen: boolean;
  setIsPreviewOpen: (isPreviewOpen: boolean) => void;
}) => {
  const { setShowNavTabs } = useAutomationsTabs();
  const { t } = useTranslation();

  const handleClick = () => {
    if (isPreviewOpen) {
      setIsPreviewOpen(false);
      setShowNavTabs(true);
    } else {
      setIsPreviewOpen(true);
      setShowNavTabs(false);
    }
  };

  return (
    <Button
      data-testid="preview-pre-arrival-form-button"
      $colorScheme="green"
      onClick={handleClick}
    >
      {isPreviewOpen
        ? t('pageAutomations.preArrivalForm.preview.closePreview')
        : t('pageAutomations.preArrivalForm.preview.previewPreArrivalForm')}
    </Button>
  );
};

export default PreviewPreArrivalFormButton;
